var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgResurrection(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "current",
    stroke: "current",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 59.457 49.735",
    height: 36,
    width: 36,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.442 35.002c-1.23-3.882-3.598-6.818-6.787-8.413-1.023-.512-2.052-.933-2.288-.935a1.773 1.773 0 0 1-.79-.233c-.262-.167-.08-.319.662-.554 3.62-1.146 6.808-3.822 8.266-6.942.455-.973.828-2.013.828-2.31 0-.304.173-.54.397-.54s.396.236.396.54c0 .297.373 1.337.828 2.31 1.458 3.12 4.646 5.796 8.266 6.942.743.235.924.387.662.554-.2.126-.555.23-.79.233-1.097.01-4.176 1.916-5.755 3.56-1.536 1.599-3.21 4.495-3.21 5.55 0 .599-.515.776-.685.238zm14.088 1.173c12.954-12.988 13.564-13.643 14.463-15.544 3.433-7.25.619-15.865-6.262-19.17C49.317.303 48 .008 45.197.001c-4.759-.014-7.248 1.185-11.916 5.74-1.83 1.787-3.428 3.248-3.551 3.248-.124 0-1.722-1.461-3.552-3.247C21.511 1.186 19.021-.014 14.262 0c-2.808.008-4.12.303-6.55 1.47C.827 4.774-1.966 13.348 1.47 20.63c.898 1.903 1.489 2.538 14.46 15.544 7.438 7.458 13.649 13.56 13.8 13.56.153 0 6.363-6.102 13.801-13.56z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgResurrection);
export default __webpack_public_path__ + "static/media/resurrection.4186b409.svg";
export { ForwardRef as ReactComponent };